import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { User, Mail, Lock, ArrowRight, Loader2, Eye, EyeOff } from "lucide-react";
import useAuth from "../hooks/useAuth";
import styles from "./Auth.module.css";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return alert("Las contraseñas no coinciden");

    setLoading(true);
    setTimeout(() => {
      register({ name: form.name, email: form.email });
      setLoading(false);
      navigate("/admin");
    }, 2000);
  };

  return (
    <motion.div className={styles.card}>
      <motion.div className={styles.header}>
        <h1 className={styles.title}>Crear tu cuenta</h1>
      </motion.div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <motion.div className={styles.inputWrapper}>
          <User size={22} className={styles.icon} />
          <input
            type="text"
            placeholder="Nombre completo"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
            className={styles.input}
          />
        </motion.div>

        <motion.div className={styles.inputWrapper}>
          <Mail size={22} className={styles.icon} />
          <input
            type="email"
            placeholder="tu@email.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            className={styles.input}
          />
        </motion.div>

        <motion.div className={styles.inputWrapper}>
          <Lock size={22} className={styles.icon} />
          <input
            type={showPass ? "text" : "password"}
            placeholder="Contraseña segura"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            className={styles.input}
          />
          <button type="button" onClick={() => setShowPass(!showPass)} className={styles.eyeBtn}>
            {showPass ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        </motion.div>

        <motion.div className={styles.inputWrapper}>
          <Lock size={22} className={styles.icon} />
          <input
            type={showPass ? "text" : "password"}
            placeholder="Repetir contraseña"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            required
            className={styles.input}
          />
        </motion.div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          disabled={loading}
          className={styles.submitBtn}
        >
          {loading ? <Loader2 className={styles.spinner} size={26} /> : "Crear cuenta gratis"}
          {!loading && <ArrowRight size={26} className={styles.arrow} />}
        </motion.button>
      </form>

      <motion.p className={styles.footer}>
        ¿Ya tenés cuenta? <Link to="/login" className={styles.link}>Iniciar sesión</Link>
      </motion.p>
    </motion.div>
  );
}